/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An action suggested by the concierge agent
 * @export
 * @interface ConciergeAction
 */
export interface ConciergeAction {
    /**
     * Type of action (booking_link, rate_alert_created, loyalty_info)
     * @type {string}
     * @memberof ConciergeAction
     */
    actionType: ConciergeActionActionTypeEnum;
    /**
     * Display label for the action
     * @type {string}
     * @memberof ConciergeAction
     */
    label: string;
    /**
     * URL for the action, if applicable
     * @type {string}
     * @memberof ConciergeAction
     */
    url?: string;
    /**
     * Additional metadata for the action
     * @type {{ [key: string]: any; }}
     * @memberof ConciergeAction
     */
    metadata?: { [key: string]: any; };
}


/**
 * @export
 */
export const ConciergeActionActionTypeEnum = {
    BookingLink: 'booking_link',
    RateAlertCreated: 'rate_alert_created',
    LoyaltyInfo: 'loyalty_info'
} as const;
export type ConciergeActionActionTypeEnum = typeof ConciergeActionActionTypeEnum[keyof typeof ConciergeActionActionTypeEnum];


/**
 * Check if a given object implements the ConciergeAction interface.
 */
export function instanceOfConciergeAction(value: object): value is ConciergeAction {
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ConciergeActionFromJSON(json: any): ConciergeAction {
    return ConciergeActionFromJSONTyped(json, false);
}

export function ConciergeActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConciergeAction {
    if (json == null) {
        return json;
    }
    return {
        
        'actionType': json['action_type'],
        'label': json['label'],
        'url': json['url'] == null ? undefined : json['url'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function ConciergeActionToJSON(json: any): ConciergeAction {
    return ConciergeActionToJSONTyped(json, false);
}

export function ConciergeActionToJSONTyped(value?: ConciergeAction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action_type': value['actionType'],
        'label': value['label'],
        'url': value['url'],
        'metadata': value['metadata'],
    };
}

